import * as React from "react"
import { useServiceStatusQuery } from "@/api/payments-api"

export const VersionInfo: React.FC = () => {
	return (
		<div className="bottom-4 right-4 text-sm text-base-500">
			v{APP_VERSION}
			{import.meta.env.DEV ? <DevInfo /> : null}
		</div>
	)
}

const DevInfo = () => {
	const serviceStatusQuery = useServiceStatusQuery()
	const version = serviceStatusQuery.data?.version

	return (
		<div>
			Revision: {REVISION}
			<br />
			BE: {version ? <>v{version}</> : <>loading</>}
		</div>
	)
}
